<template>
    <div class="col-md-offset-3 col-md-6 col-xs-12 mt-md-9 mt-2">
        <h4 class="text-center mb-6">Кем вы хотите быть?</h4>
        <div class="box">
            <div class="box-body p-md-6">
                <div class="row">
                    <div @click="group=2" class="col-md-6 pr-2">
                        <div :class="'select_card '+ ((this.group==2)?'active_select_card':'')">
                            <center><img class="image-login mb-5 mt-4" src="../assets/group2.svg"></center>
                            <h4 class="text-center">Я рекламодатель</h4>
                            <p class="text-center text-help pb-4">Вы будете публиковать рекламу на доступных площадках</p>
                        </div>
                    </div>
                    <div @click="group=1" class="col-md-6 pl-2">
                        <div :class="'select_card '+ ((this.group==1)?'active_select_card':'')">
                            <center><img class="image-login mb-5 mt-4" src="../assets/group1.svg"></center>
                            <h4 class="text-center">Я публикатор</h4>
                            <p class="text-center text-help pb-4">Вы будете публиковать рекламу у себя в сообществах</p>
                        </div>
                    </div>
                </div>
                <el-button v-if="group" @click="setGroup()" class="btn-block mt-6" type="primary">
                    Выбрать
                </el-button>
            </div>
            <div v-if="loader" class="overlay"> <i class="fa feather icon-refresh-ccw fa-spin"></i> </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "mainVue",
        data: function() {
            return {
                group: 0,
                loader: 0,
                error: ''
            }
        },
        methods: {
            setGroup() {
                this.$store.commit('user/setError', '');

                this.loader = 1;
                this.$store.dispatch('user/setGroup', this.group).then(() => {
                    this.loader = 0;

                    let error = this.$store.getters['user/getLastError'];
                    if (!error) this.pageLoad();
                });
            },
            pageLoad() {
                this.$store.dispatch('user/getUserData').then(() => {
                    let user = this.$store.getters['user/getUser'];
                    if (user.group == 1) this.$router.push('/publisher');
                    if (user.group == 2) this.$router.push('/customer');
                });
            }
        },
        created() {
            this.pageLoad();
        }
    }
</script>

<style scoped>
    @import "../css/auth.css";
    .box {
        box-shadow: 0px 4px 15px rgba(56, 154, 255, 0.25);
    }
    .image-login {
        width: 85px;
    }
    h4 {
        font-size: 25px;
        font-weight: 400;
    }
    .data-input {
        margin-bottom: 9px;
        margin-top: 9px;
        padding-top: 7px;
    }
    .text-help {
        font-size: 15px;
        color: #6e6e6e;
        font-weight: 100;
    }
    .btn-block {
        font-weight: 400;
        padding: 16px;
    }
    .reset {
        position: absolute;
        right: 54px;
        width: 10px;
        margin-top: 39px;
    }
    .select_card:hover,.active_select_card {
        cursor: pointer;
        background: rgba(101, 177, 255, 0.1);
        border-radius: 10px;
    }
</style>
